export const HIGHLIGHT_CLASS = 'highlight-flash';

export const flashElementById = (id: string): void => {
  const element = document.getElementById(id);
  if (!element) return;

  element.scrollIntoView({ behavior: 'smooth' });

  element.classList.remove(HIGHLIGHT_CLASS);
  element.classList.add(HIGHLIGHT_CLASS);

  element.addEventListener('animationend', () => element.classList.remove(HIGHLIGHT_CLASS), { once: true });
};
